import React from "react";
import Button from "@mui/material/Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

interface SnNavBtnProps {
  text: string;
  onClick: () => void;
  inputRef?: any;
}

export function SnNavBtn({ text, onClick, inputRef }: SnNavBtnProps) {
  return (
    <Button
      ref={inputRef}
      variant="outlined"
      size="small"
      onClick={() => {
        onClick();
      }}
      sx={{
        // backgroundColor: "rgb(186,191,198)",
        // border: "1px solid rgb(167,175,183)",
        backgroundColor: "rgb(167,175,183)",
        border: "1px solid rgb(186,191,198)",
        borderRadius: "0px",
        padding: "3px 3px",
        marginBottom: "10px",
        color: "white",
        fontWeight: "bold",
        width: "90px",
        height: "35px",
        "&:hover": {
          backgroundColor: "rgb(11,12,105)",
          color: "white",
        },
        "& .MuiButton-startIcon": {
          marginRight: "0px",
        },
        // '&:active': {
        //   backgroundColor: 'rgb(0,0,255)',
        //   color: 'white',
        // },
        // '&:focus': {
        //   backgroundColor: 'rgb(0,0,255)',
        //   color: 'white',
        // },
      }}
      startIcon={<ArrowDropDownIcon />}
    >
      {text}
    </Button>
  );
}

export default React.memo(SnNavBtn);
